import {Crop, Municipality, StringIdOption, Use} from '@/domain/services/Clas';

export const toSelectInputOption = (items: Array<Crop> | Array<Use> | Array<Municipality> | Array<string> | Array<number>): Array<StringIdOption> => {

  if (typeof items[0] === 'string' || typeof items[0] === 'number') {
    // strings o numbers
    return (items as Array<string | number>).map(value => ({
      id: value.toString(),
      label: value.toString(),
    }));
  } else {
    return (items as Array<Crop | Use | Municipality>)
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(item => ({
        id: item.uuid,
        label: item.name,
      }));
  }
  
};